export function ConvertLanguageCodeToJezikID(langCode) {
  switch (langCode) {
    case "hr":
      return 3;
    case "bs":
      return 2;
    case "sr":
      return 2;
    case "sl":
      return 5;
    case "en":
      return 4;
    case "de":
      return 6;
    default:
      return 4; //default en
  }
}



// WEBPACK FOOTER //
// ./src/HOCs/Helpers/LanguageConverter.js